module.exports = __webpack_public_path__ + "static/SharedSecrets-37289d3b3a76a35c70f25d7f188d605e.png";